import { styled } from '@mui/material/styles';
import { TextField } from '@mui/material';

const getContrastText = (theme) => {
  const color = theme.palette.primary.dark;
  return theme.palette.getContrastText(color);
};

export const CircularProgressBox = styled('div')({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: 40,
  minWidth: 90,
});

export const StatusSelect = styled(TextField)(({ theme }) => {
  const selectColor = getContrastText(theme);
  return {
    borderRadius: 4,
    marginTop: theme.spacing(1),
    minWidth: 0,
    width: '100%',
    maxWidth: '100%',
    '& .MuiInputLabel-root': {
      color: selectColor,
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: selectColor,
    },
    '& .MuiInputBase-root': {
      minWidth: 0,
    },
    '& .MuiOutlinedInput-root': {
      color: selectColor,
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: selectColor,
      },
    },
    '& .MuiSelect-select': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    '& .MuiSelect-icon': {
      color: selectColor,
    },
    '& .MuiFormHelperText-root': {
      color: selectColor,
      marginLeft: 0,
      maxWidth: '100%',
    },
  };
});
